import { styled } from '@stitches/react';
import ChatSidebar from '../components/ChatSidebar';
import ChatWindow from '../components/ChatWindow';
import { useState } from 'react';
import { useChat } from '../context/ChatContext';

const ChatContainer = styled('div', {
  display: 'flex',
  height: '100vh',
});

function Chat() {
  const [selectedChat, setSelectedChat] = useState(null);

  return (
    <ChatContainer>
      <ChatSidebar
        onChatSelect={setSelectedChat}
        selectedChat={selectedChat}
      />
      {selectedChat && (
        <ChatWindow chat={selectedChat} />
      )}
    </ChatContainer>
  );
}

export default Chat;